import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spinner } from './ui/spinner';

interface AdminRouteProps {
  children: React.ReactNode;
}

/**
 * Wraps routes that require the user to be in the Cognito 'admins' group.
 * Redirects to /login if unauthenticated, or to /ask if authenticated but not an admin.
 */
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/ask" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
